import { Input, InputProps } from '@/shadcn-ui/input';
import { cn } from '@/shadcn-ui/utils';
import React from 'react';

const FilterOptionTextInput = React.forwardRef<
  React.ElementRef<typeof Input>,
  InputProps
>(({ className, ...props }: InputProps, ref) => {
  return (
    <Input
      ref={ref}
      type="text"
      className={cn(
        'body w-full border border-flexcar-neutral80 px-[16px] py-[12px] text-center shadow-inputShadow',
        className
      )}
      {...props}
    />
  );
});
FilterOptionTextInput.displayName = 'FilterOptionTextInput';

export { FilterOptionTextInput };
